module.exports = __webpack_public_path__ + "img/11.2faa903f.png";